import { createFileRoute } from '@tanstack/react-router';

import { AgentsPage } from '@/pages/agents/agents-page';

/**
 * `/agents` index — the marketplace + my-agents list.  Sibling of
 * `agents.$agentId` (detail) under the `/agents` layout.
 */
export const Route = createFileRoute('/agents/')({ component: AgentsPage });
